module.exports = __webpack_public_path__ + "img/polygon_small.718543b1.svg";